module.exports = __webpack_public_path__ + "static/media/s3.e3db663b.wav";